import { useGetBenefits } from '@/common/integrations/menhir/employee/benefits/benefits.hooks';

export function useAvailableBenefitCategories() {
  const { benefits, ...rest } = useGetBenefits();

  return {
    meal: benefits?.find((benefit) => benefit.slug === 'meals') ?? null,
    benefits: benefits?.filter((benefit) => benefit.slug !== 'meals') ?? [],
    ...rest,
  };
}
